(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/views/partials/video.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/views/partials/video.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.emp_video_player=_cmps.emp_video_player||{};
_cmps.emp_video_player.templates=_cmps.emp_video_player.templates||{};
svs.components.emp_video_player.templates.video = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"emp-partial emp-video\">\n  <video autoplay class=\"\n    video-js\n    vjs-16-9\n    vjs-default-skin\n    vjs-big-play-centered\n    vjs-show-big-play-button-on-pause\n  \"></video>\n  </div>\n</div>\n\n";
},"useData":true});
Handlebars.partials['components-components-emp_video_player-video'] = svs.components.emp_video_player.templates.video;
})(svs, Handlebars);


 })(window);